module.exports = __webpack_public_path__ + "img/fen.8fefa513.png";